import { Typography } from '@mui/material';

import './PageHeader.css';
import { PageHeaderProps } from './PageHeader.types';

/**

 */
export function PageHeader({
  activeTab,
  dataInitialized,
  isEditing,
  exclusionUpdatesCount,
  onTabChange,
  onAddUser,
  onSaveExclusions,
  onResetExclusions,
  isSaving
}: PageHeaderProps) {
  const addDisabled = !dataInitialized || isEditing;
  return (
    <>
      <div className="user-management-page-header">
        <div className="user-management-page-header-content">
          <Typography className="user-management-page-title">Управління користувачами</Typography>
          {activeTab === 'users' ? (
            <button
              onClick={onAddUser}
              disabled={addDisabled}
              className={`user-management-add-user-button ${addDisabled ? 'disabled' : ''}`}
            >
              Додати користувача
            </button>
          ) : (
            <div className="user-management-marketers-actions">
              {exclusionUpdatesCount > 0 ? (
                <>
                  <button onClick={onResetExclusions} className="user-management-reset-button">
                    Скасувати
                  </button>
                  <button onClick={onSaveExclusions} disabled={isSaving} className="user-management-save-button">
                    Зберегти зміни
                  </button>
                </>
              ) : (
                <div className="user-management-button-placeholder"></div>
              )}
            </div>
          )}
        </div>

        <div className="user-management-tabs">
          <button
            onClick={() => onTabChange('users')}
            className={`user-management-tab ${activeTab === 'users' ? 'active' : ''}`}
          >
            Користувачі
          </button>
          <button
            onClick={() => onTabChange('marketers')}
            className={`user-management-tab ${activeTab === 'marketers' ? 'active' : ''}`}
          >
            Маркетологи
          </button>
        </div>
      </div>
    </>
  );
}
